import common from "../../../common";
import TutorialFinger from "../../../reusableModules/TutorialFinger";
import EggBowl from "../EggBowl";

export default class IngredientsAdding extends PIXI.Container {
    constructor() {
        super();
        this._innerContainer = null;

        this._ingredients = [];
        this._ingredientIndex = 0;
        this._tutorialFinger = null;
        this._tutorialPositions = [];
        this._bowlPosition = null;
        this._bowlBounds = null;

        this._bindings = {};
        this._signals = {};
        this._signals.ingredientRemoved = new P3.utils.MiniSignal();
        this._signals.stageComplete = new P3.utils.MiniSignal();

        this.setupContainer();
    }

    destroy(){
        for (const i in this._bindings) {
            if (this._bindings.hasOwnProperty(i)) {
                const binding = this._bindings[i];
                binding.detach();
            }
        }
        this._bindings = {};
    }

    update(){
        if(this._tutorialFinger){
            this._tutorialFinger.update();
        }
    }

    setupContainer(){
        this._innerContainer = new PIXI.Container();
        this.addChild(this._innerContainer);

        let bk = new PIXI.Sprite(P3.assets.texture('bg_kitchen'));
        bk.position.set(bk.width * 0.5, bk.height * 0.5);
        bk.width = 1900;
        bk.anchor.set(0.5);
        bk.visible = false;
        this._innerContainer.addChild(bk);

        let mask = new PIXI.Sprite(PIXI.Texture.WHITE);
        mask.position.set(bk.width * 0.5, bk.height * 0.5);
        mask.anchor.set(0.5, 0);
        mask.width = common.STAGE_WIDTH;
        mask.height = 600;
        mask.position.y -= (common.STAGE_HEIGHT * 0.5 + 15);
        this.addChild(mask);
        this._innerContainer.mask = mask;

        this._bowlBounds = new PIXI.Sprite(P3.assets.texture(''));
        this._bowlBounds.anchor.set(0.5);
        this._bowlBounds.width = 200;
        this._bowlBounds.height = common.STAGE_HEIGHT;
        this._bowlBounds.position.set(common.STAGE_WIDTH * 0.5 - 75, common.STAGE_HEIGHT * 0.5);
        this._bowlBounds.visible = false;
        this.addChild(this._bowlBounds);
    }

    createTutorial(autoPlay){
        if(this._tutorialFinger != null){
            this.removeChild(this._tutorialFinger);
            this._tutorialFinger.destroy();
            this._tutorialFinger = null;
        }

        if(this._ingredientIndex < 0) return;

        this._tutorialFinger = new TutorialFinger({
            x: this._tutorialPositions[this._tutorialPositions.length - 1].x + 75,
            y: this._tutorialPositions[this._tutorialPositions.length - 1].y
        }, 10, -1);
        this.addChild(this._tutorialFinger);
        this._tutorialFinger.fade(true, 500, false);
        this._tutorialFinger.clickDown();
        this._tutorialFinger.addStep(new P3.utils.TWEEN.Tween(this._tutorialFinger._view, this.tweens)
            .to({
                x: this._bowlPosition.x + 75,
                y: this._bowlPosition.y - 150
            }, 1000)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut));
        this._tutorialFinger.clickUp();
        this._tutorialFinger.fade(false, 500, false);
        this._tutorialFinger.addDelay(1000);
        this._tutorialFinger.play();
        !autoPlay && this._tutorialFinger.turnOff();
    }


    animateInIngredients(){
        for (let i = 0; i < this._ingredients.length; i++) {
            const argument = this._ingredients[i]._animIn;
            argument.start();
        }
    }

    animateIngredients(object, position, time, last = false){
        let inTween = new P3.utils.TWEEN.Tween(object, this.tweens)
            .to({
                x: position.x,
                y: position.y - 10
            }, time)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut);

        let downTween = new P3.utils.TWEEN.Tween(object, this.tweens)
            .to({
                y: position.y + 10
            }, 1000)
            .onComplete(()=>{
                object.interactive = true;
                this.createTutorial(true);
            })
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut);
        inTween.chain(downTween);
        return inTween;
    }

    checkIngredientBounds(sprite){
        let collided = false;
        let col = (r1, r2, tuner)=> {
            if (!tuner || tuner <= 0) tuner = 1;

            let isFlour = false;
            if(r1.texture.textureCacheIds[0] === "ing_flour_shelf.png"){
                isFlour = true;
                //console.log("flour");
            }
            r1 = r1.getBounds();
            r2 = r2.getBounds();

            if(isFlour){
                r1.x += 75;
            }
            return !(r2.x > (r1.x + r1.width * tuner) ||
                (r2.x + r2.width * tuner) < r1.x ||
                r2.y > (r1.y + r1.height * tuner) ||
                (r2.y + r2.height * tuner) < r1.y);
        };


        let spriteToCompare = (sprite instanceof EggBowl) ? sprite._eggContainer._singleEgg : sprite.view;

        if(col(spriteToCompare, this._bowlBounds)){
            collided = true;
            sprite.playAnimation(true);
        }else{
            sprite.rotateWithoutParticle();
            //sprite.playAnimation(false);
        }
        if(this._tutorialFinger)
            this._tutorialFinger.turnOff();

        return collided;
    }

    removeTutorialFinger(){
        if(this._tutorialFinger){
            this.removeChild(this._tutorialFinger);
            this._tutorialFinger.destroy();
            this._tutorialFinger = null;
        }
    }
}